{
  "header": {
    "eyebrow": "Betalingen",
    "title": "QR-betaling",
    "description": "QR-code laadsessies en betaalstickers.",
    "action": "Open EVinity-dashboard"
  },
  "sessions": {
    "title": "QR-sessies",
    "count": "{{count}} sessie",
    "count_other": "{{count}} sessies",
    "searchPlaceholder": "Zoek op station, locatie of transactie",
    "searchAria": "Zoek QR-sessies",
    "openExternal": "Openen in CPMS",
    "perKwh": "{{value}}/kWh",
    "columns": {
      "location": "Locatie",
      "status": "Status",
      "started": "Gestart",
      "amount": "Bedrag",
      "price": "Prijs",
      "actions": "Acties"
    },
    "status": {
      "initiated": "Geïnitieerd",
      "checkedOut": "Afgerekend",
      "charging": "Laden",
      "completed": "Voltooid",
      "cancelled": "Geannuleerd"
    },
    "empty": {
      "title": "Geen QR-sessies",
      "description": "Geen QR-sessies komen overeen met de zoekopdracht."
    },
    "error": {
      "title": "QR-sessies laden mislukt",
      "description": "Er ging iets mis bij het laden van de QR-sessies. Probeer het opnieuw."
    }
  },
  "stickers": {
    "title": "QR-stickers",
    "count": "{{count}} gekoppeld",
    "searchPlaceholder": "Zoek op sticker, station of locatie",
    "searchAria": "Zoek QR-stickers",
    "add": "Sticker toevoegen",
    "idLabel": "ID {{id}}",
    "columns": {
      "sticker": "Sticker",
      "location": "Laadstation",
      "actions": "Acties"
    },
    "actions": {
      "edit": "Koppeling bewerken",
      "share": "QR-link kopiëren",
      "download": "QR-code downloaden",
      "delete": "Koppeling verwijderen"
    },
    "empty": {
      "title": "Geen gekoppelde stickers",
      "description": "Geen stickers komen overeen met de zoekopdracht. Voeg er een toe om te koppelen aan een laadstation."
    },
    "error": {
      "title": "QR-stickers laden mislukt",
      "description": "Er ging iets mis bij het laden van de QR-stickers. Probeer het opnieuw."
    },
    "dialog": {
      "addTitle": "QR-sticker koppelen",
      "editTitle": "QR-sticker bewerken",
      "description": "Koppel een sticker aan het laadstation waarvoor deze een sessie moet starten.",
      "stickerLabel": "Sticker",
      "stickerPlaceholder": "Selecteer een sticker…",
      "stickerOption": "Sticker {{id}}",
      "stationLabel": "Laadstation",
      "stationPlaceholder": "Selecteer een laadstation…",
      "cancel": "Annuleren",
      "save": "Opslaan"
    },
    "deleteDialog": {
      "title": "Stickerkoppeling verwijderen",
      "description": "Sticker {{id}} ontkoppelen van het laadstation? De sticker keert terug naar de pool.",
      "confirm": "Koppeling verwijderen"
    },
    "toasts": {
      "linked": "Sticker {{id}} gekoppeld.",
      "updated": "Sticker {{id}} bijgewerkt.",
      "unlinked": "Sticker {{id}} ontkoppeld.",
      "copied": "Link gekopieerd: {{url}}",
      "saveFailed": "Kon de sticker niet opslaan. Probeer het opnieuw.",
      "deleteFailed": "Kon de koppeling niet verwijderen. Probeer het opnieuw.",
      "copyFailed": "Kon de link niet kopiëren.",
      "qrFailed": "Kon de QR-code niet genereren."
    }
  }
}
